module.exports = __webpack_public_path__ + "static/media/logo-caldeiraogrande.44f290b3.png";